export const DEFAULT_SUMMARY_LABELS = {
    points: (count, first, last) => count === 1 ? `1 point, ${first}` : `${count} points from ${first} to ${last}`,
    series: (series, min, max, last) => `${series}: low ${min}, high ${max}, latest ${last}`,
    categories: (series, total, maxCategory, max) => `${series}: total ${total}, highest ${maxCategory} at ${max}`,
    noData: 'No data',
};
/** Min, max, latest and total of the finite values (gaps ignored), or undefined if none. */
export function seriesStats(values) {
    let min = Infinity;
    let max = -Infinity;
    let last = NaN;
    let total = 0;
    let maxIndex = -1;
    let count = 0;
    values.forEach((v, i) => {
        if (v === null)
            return;
        count++;
        total += v;
        last = v;
        if (v < min)
            min = v;
        if (v > max) {
            max = v;
            maxIndex = i;
        }
    });
    return count ? { min, max, last, total, maxIndex, count } : undefined;
}
/** "Sessions: low 1,204, high 3,410, latest 2,960" for one series. */
export function describeTrend(label, values, format, labels) {
    const s = seriesStats(values);
    if (!s)
        return `${label}: ${labels.noData}`;
    return labels.series(label, format(s.min), format(s.max), format(s.last));
}
//# sourceMappingURL=summary.js.map